import React from 'react';

import { Section } from '../..';
import { defaultPropTypes } from '../AdditionalData';
import { checkSectionCondition } from '../../../Form.helpers';

const RecommendingPerson = ({ field, translations }) => {
    const renderedSection = checkSectionCondition(field.value);

    return (
        <Section.Conditional
            condition={Boolean(field.order) && renderedSection}
            title={translations.recommendingPerson}
        >
            {({ renderField }) => (
                renderField(translations.recommendingPerson, field.value)
            )}
        </Section.Conditional>
    );
};
RecommendingPerson.propTypes = defaultPropTypes;
export default RecommendingPerson;
